function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon-circle-duplicate");

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.99991,
  cy: 21.99997,
  r: 22,
  fill: "#ededed"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 18.99991,
  y: 14,
  width: 10,
  height: 13,
  rx: 1,
  strokeWidth: 1.25,
  stroke: "#333",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  fill: "none"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.99991,29a1,1,0,0,1-1,1h-8a1,1,0,0,1-1-1V18a1,1,0,0,1,1-1",
  fill: "none",
  stroke: "#333",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 1.25
});

const SvgCircleDuplicate = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ee562e8f-846d-4df0-88e6-81d8b8929d30",
    "data-name": "Layer 1",
    viewBox: "0 0 43.99991 44.00006",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCircleDuplicate, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/circle-duplicate.212d6592.svg";
export { ForwardRef as ReactComponent };